import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

interface AssignmentSkill {
  id: string;
  skill: string;
  skillNormalized: string;
  isMustHave: boolean;
}

interface AssignmentContact {
  name: string | null;
  email: string | null;
  phone: string | null;
  profilePictureUrl: string | null;
}

interface AssignmentSourceData {
  company: string | null;
  duration: string | null;
  rate: string | null;
  scope: string | null;
  remote: boolean | null;
  remoteness: string | null;
  level: string | null;
  type: string | null;
  url: string | null;
  platform: string | null;
  startDate: string | null;
  endDate: string | null;
  fullDescription: string | null;
  contact: AssignmentContact | null;
}

interface Assignment {
  id: string;
  tenantId: string;
  source: string;
  sourceId: string | null;
  title: string;
  location: string | null;
  status: string;
  publishedAt: string | null;
  skills: AssignmentSkill[];
  description: string | null;
  sourceData: AssignmentSourceData | null;
}

export function useAssignments(status?: string, page = 1, limit = 50) {
  const statusParam = status ? `&status=${status}` : '';
  return useQuery({
    queryKey: ['assignments', status, page, limit],
    queryFn: () => apiFetch<Assignment[]>(`/assignments?page=${page}&limit=${limit}${statusParam}`)
  });
}

export function useAssignment(id: string | null) {
  return useQuery({
    queryKey: ['assignment', id],
    queryFn: () => apiFetch<Assignment>(`/assignments/${id}`),
    enabled: !!id
  });
}

export type { Assignment, AssignmentSkill, AssignmentSourceData, AssignmentContact };
